/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Other_PlansInputs */

const en_plan_other_plans = /** @type {(inputs: Plan_Other_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other plans`)
};

const es_plan_other_plans = /** @type {(inputs: Plan_Other_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otros planes`)
};

/**
* | output |
* | --- |
* | "Other plans" |
*
* @param {Plan_Other_PlansInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_other_plans = /** @type {((inputs?: Plan_Other_PlansInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Other_PlansInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_other_plans(inputs)
	return en_plan_other_plans(inputs)
});